<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="left-right-row row">
                    <div class="right">
                        <router-link
                            :to="{ name: 'admin.users.new' }"
                            class="btn btn-primary mb-2"
                        >
                            <i class="fa fa-plus" /> New User
                        </router-link>
                    </div>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email Address</th>
                            <th>Office</th>
                            <th>Engineer</th>
                            <th>Admin</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(user, index) in users"
                            :key="index"
                        >
                            <td>
                                <router-link :to="{ name: 'admin.users.edit', params: { id: user.id } }">
                                    {{ user.name }}
                                </router-link>
                            </td>
                            <td>
                                {{ user.email }}
                            </td>
                            <td>
                                <i
                                    class="fa fa-check"
                                    v-if="user.office_access"
                                />
                            </td>
                            <td>
                                <i
                                    class="fa fa-check"
                                    v-if="user.engineer_access"
                                />
                            </td>
                            <td>
                                <i
                                    class="fa fa-check"
                                    v-if="user.admin_access"
                                />
                            </td>
                            <td>
                                <router-link :to="{ name: 'admin.users.edit', params: { id: user.id } }">
                                    <i class="fa fa-pencil-alt" />
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import UsersService from "../../../../services/UsersService";

export default {
    data: function() {
        return {
            loading: false,
            users: [],
            usersService: UsersService
        };
    },

    created: function() {
        this.loading = true;
        setTimeout(() => {
            this.usersService
                .search()
                .then(response => {
                    this.users = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });
        }, 500);
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/admin/users/UserIndexComponent.vue